type ENV = 'dev' | 'prod' | 'demo'

export const currentEnv: ENV = "dev";

const env: ENV = currentEnv;

export const Env = env

const API_DEV_URL = "https://happypro-api.volkeno.com";
const API_DEMO_URL = "https://api.happypro.fr";
const API_PROD_URL = "https://api.happypro.fr";

export const APP_URL_DEV = "https://happy-pro.volkeno.com/";
export const APP_URL_DEMO = "https://app.happypro.fr/";
export const APP_URL_PROD = "https://app.happypro.fr/";

export const SOCKET_DEV_URL = "https://happy-pro-socket.volkeno.com";
export const SOCKET_DEMO_URL = "https://socket.happypro.fr";
export const SOCKET_PROD_URL = "https://socket.happypro.fr";

function processApiUrl() {
  if (env === "prod") return API_PROD_URL;
  if (env === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

function processAppUrl() {
  if (env === "prod") return APP_URL_PROD;
  if (env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processSocketUrl() {
  if (env === "prod") return SOCKET_PROD_URL;
  if (env === "demo") return SOCKET_DEMO_URL;
  return SOCKET_DEV_URL;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();
export const SocketUrl = processSocketUrl();

export const GoogleApikey = "AIzaSyD0klc1PQS8QK--Be3rF3i8kW_idy04AVQ";